'use client';

import { Image } from '@utilities/Image';
import { Link } from '@utilities/Link';

import styles from './LogoSlide.module.scss';

export interface LogoCarouselItem {
  id: string;
  href?: string;
  defaultLogoUrl: string;
  hoverLogoUrl: string;
  isExternalLink?: boolean;
  title: string;
  width?: number;
  height?: number;
}

export const LogoSlide = ({
  id,
  href,
  defaultLogoUrl,
  hoverLogoUrl,
  isExternalLink,
  width,
  height,
  title,
}: LogoCarouselItem) => {
  const content = (
    <>
      <Image
        src={defaultLogoUrl}
        width={width}
        height={height}
        alt={`${id} icon`}
        title={title}
        className={styles.defaultLogo}
      />
      <Image
        src={hoverLogoUrl}
        width={width}
        height={height}
        alt={`${id} icon`}
        title={title}
        className={styles.hoverLogo}
      />
    </>
  );

  return (
    <li key={id} className={styles.logoItem} style={{ width, height }}>
      {href ? (
        <Link
          href={href}
          {...(isExternalLink ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        >
          {content}
        </Link>
      ) : (
        content
      )}
    </li>
  );
};
